<ng-template [ngIf]="lecture">
	<div attr.id="content-heading-{{lecture.system_codename}}" (click)="open($event)" class="card-header accordion-trigger collapsed" data-toggle="collapse" tabindex="0" attr.data-target="#content-{{lecture?.system_codename}}" aria-expanded="false" attr.aria-controls="content-{{lecture?.system_codename}}">
		<div class="row align-items-center">
<!--			<div class="col-md-auto lesson-number" *ngIf="lessonNumber">{{lessonNumber}}</div>-->
			<div class="col-12 col-md content-details">
				<h3 class="title" [innerHTML]="lecture.title | simpleMd"></h3>
				<div class="content-properties">
					<ng-container *ngIf="lecture">
						<span class="duration">{{ lecture.duration }}</span>
						<span class="instructor" *ngIf="lecture.instructors && lecture.instructors.length"> &mdash; {{ lecture.instructors[0] | instructorName }}</span>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
	<div attr.id="content-{{lecture?.system_codename}}" class="accordion-panel collapse" attr.aria-labelledby="content-heading-{{lecture?.system_codename}}" data-parent="#content-list">
		<div class="card-body">
			<div [ngSwitch]="currentSelection">
				<ng-template ngSwitchCase="lecture" ngSwitchDefault>
					<app-lecture *ngIf="lecture.video_id; else contentLoadFailed" [courseId]="courseId" [lecture]="lecture" [showVideo]="currentLessonId === lecture.url_slug"></app-lecture>
				</ng-template>
			</div>
			<ng-template #contentLoadFailed>
				<div class="text text-danger">Unable to load content.</div>
			</ng-template>
			<ng-content></ng-content>
		</div>
	</div>
</ng-template>
